import { useMemo, useState } from "react";
import type { ProjectTag } from "@/types/api";

const MAX_TAG_LENGTH = 30;

export interface UseCreateTagFormResult {
  value: string;
  setValue: (next: string) => void;
  trimmed: string;
  isDuplicate: boolean;
  canSubmit: boolean;
  reset: () => void;
}

export function useCreateTagForm(
  availableTags: ProjectTag[],
): UseCreateTagFormResult {
  const [value, setValue] = useState("");
  const trimmed = value.trim();

  const isDuplicate = useMemo(() => {
    if (trimmed.length === 0) return false;
    const lower = trimmed.toLowerCase();
    return availableTags.some((t) => t.name.toLowerCase() === lower);
  }, [availableTags, trimmed]);

  const canSubmit =
    trimmed.length > 0 && trimmed.length <= MAX_TAG_LENGTH && !isDuplicate;

  return {
    value,
    setValue,
    trimmed,
    isDuplicate,
    canSubmit,
    reset: () => setValue(""),
  };
}

export const TAG_NAME_MAX_LENGTH = MAX_TAG_LENGTH;
